import React from "react"
import Layout from "../components/Layout"
import Anouncement from "../components/Anouncement"
import SecondJumbotron from "../components/SecondJumbotron"
import FeaturesSection from "../components/FeaturesSection"
import { Container } from "react-bootstrap"
import ProductCards from "../components/ProductCards"
import { graphql } from "gatsby"
import DesignSection from "../components/DesainSection"
import SEO from "../components/seo"

export default function katalog({
  data: {
    allMarkdownRemark: { edges },
  },
}) {
  const products = edges

  return (
    <Layout>
      <SEO title="Katalog" />

      <Anouncement />
      <SecondJumbotron />
      <Container className="mt-5">
        <FeaturesSection />
        <section className="py-5">
          <h3 className="font-weight-800 text-center mb-5">Katalog Kaos</h3>
          <ProductCards products={products} />
        </section>
      </Container>
      <DesignSection />
    </Layout>
  )
}

export const pageQuery = graphql`
  query allProducts {
    allMarkdownRemark {
      edges {
        node {
          frontmatter {
            title
            image
            onSale
            price
            slug
          }
          id
        }
      }
    }
  }
`
